// @ts-nocheck
import {
  Record,
  RepeatableElement,
  SectionElement,
  RepeatableValue,
  RepeatableItemValue,
  CalculatedElement,
} from '@fulcrumapp/fulcrum-core';

export default class EditorLevel {
  constructor(record, rootElement, feature, parentValues, repeatableValue) {
    this._record = record;
    this._rootElement = rootElement;
    this._feature = feature;
    this._parentValues = parentValues;
    this._repeatableValue = repeatableValue;
  }

  get id() {
    if (this.isRepeatableIndexLevel) {
      return this.repeatableValue.element.key;
    } if (this.isSectionLevel) {
      return this.rootElement.key;
    } if (this.isRepeatableLevel) {
      return this.feature.id;
    } if (this.isRecordLevel) {
      return 'root';
    }

    throw new Error('Invalid level');
  }

  get displayName() {
    if (this.isRepeatableIndexLevel) {
      return `${this.repeatableValue.element.label} (${this.repeatableValue.displayValue})`;
    } if (this.isSectionLevel) {
      return this.rootElement.label;
    } if (this.isRepeatableLevel) {
      return this.feature.displayValue || 'Untitled';
    } if (this.isRecordLevel) {
      return this.feature.displayValue || 'Untitled';
    }

    throw new Error('Invalid level');
  }

  get isRepeatableIndexLevel() {
    return this.repeatableValue instanceof RepeatableValue;
  }

  get isSectionLevel() {
    return this.rootElement instanceof SectionElement;
  }

  get isRepeatableLevel() {
    return this.feature instanceof RepeatableItemValue
           && this.rootElement instanceof RepeatableElement;
  }

  get isRecordLevel() {
    return this.feature instanceof Record
           && this.rootElement == null;
  }

  get isMapEnabled() {
    if (this.isRepeatableIndexLevel) {
      return this.repeatableValue.element.isGeometryEnabled;
    } if (this.isRecordLevel) {
      return this.record.form.isGeometryEnabled;
    } if (this.isRepeatableLevel) {
      return this.feature.element.isGeometryEnabled;
    }

    return false;
  }

  get record() {
    return this._record;
  }

  get rootElement() {
    return this._rootElement;
  }

  get parentValues() {
    return this._parentValues;
  }

  get feature() {
    return this._feature;
  }

  set feature(feature) {
    this._feature = feature;
    this._valuesForConditions = null;
  }

  get repeatableValue() {
    return this._repeatableValue;
  }

  get valuesForConditions() {
    this._valuesForConditions = this.feature.formValues.copy();

    if (this._parentValues) {
      const clone = this._parentValues.copy();
      Object.keys(clone._values).forEach((property) => {
        // eslint-disable-next-line no-prototype-builtins
        if (this._valuesForConditions._values.hasOwnProperty(property)) {
          delete clone._values[property];
        }
      });
      this._valuesForConditions.merge(clone);
    }

    return this._valuesForConditions;
  }

  get calculationExpressions() {
    if (!this._calculationExpressions) {
      const calculatedElementRoot = CalculatedElement.findCalculatedElementRoot(this.record.form,
        this.rootElement || this.record.form);

      const calculatedElements = CalculatedElement.findCalculatedElementsForContainer(calculatedElementRoot);

      const expressions = calculatedElements.map((element) => ({
        key: element.key,
        dataName: element.dataName,
        expression: element.expression || '',
      }));

      this._calculationExpressions = expressions;
    }

    return this._calculationExpressions;
  }
}
